import React, { useRef } from 'react'
import { Helmet } from 'react-helmet-async'
import styled from 'styled-components'



const ChartWrapper = styled.div`
  height: 100%;
`

const Chart = () => {
  const chartRef = useRef<HTMLDivElement>()
  return (
    <div className="video-responsive">
<iframe title="advanced chart TradingView widget" lang="en" id="tradingview_6a08d"  scrolling="no"  src="https://www.tradingview.com/widgetembed/?hideideas=1&amp;overrides=%7B%7D&amp;enabled_features=%5B%5D&amp;disabled_features=%5B%5D&amp;locale=en#%7B%22symbol%22%3A%22PANCAKESWAP%3AVIZSLASWAPWBNB_8D3CF6.USD%22%2C%22frameElementId%22%3A%22tradingview_6a08d%22%2C%22interval%22%3A%22D%22%2C%22hidetoptoolbar%22%3A%221%22%2C%22hidesidetoolbar%22%3A%221%22%2C%22symboledit%22%3A%221%22%2C%22saveimage%22%3A%220%22%2C%22backgroundColor%22%3A%22rgba(0%2C%200%2C%200%2C%201)%22%2C%22gridColor%22%3A%22rgba(0%2C%200%2C%200%2C%200.06)%22%2C%22studies%22%3A%22%5B%5D%22%2C%22theme%22%3A%22dark%22%2C%22style%22%3A%221%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22studies_overrides%22%3A%22%7B%7D%22%2C%22utm_source%22%3A%22www.tradingview.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22chart%22%2C%22utm_term%22%3A%22PANCAKESWAP%3AVIZSLASWAPWBNB_8D3CF6.USD%22%2C%22page-uri%22%3A%22www.tradingview.com%2Fwidget%2Fadvanced-chart%2F%22%7D"/>
 </div>  
  )
}

export default Chart
